/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
export default {
    SET_LIST(state, list) {
        state.list = list
    },
    PREPEND(state, item) {
        // Skip duplicates if the same broadcast event arrives twice
        // (multiple tabs, or WS replay just after a fetchAll).
        const existingIdx = state.list.findIndex((n) => n.id === item.id)
        if (existingIdx !== -1) {
            // Merge: keep the apiId from whichever copy has one.
            const existing = state.list[existingIdx]
            state.list.splice(existingIdx, 1, {
                ...existing,
                ...item,
                apiId: item.apiId || existing.apiId
            })
            return
        }
        state.list.unshift(item)
    },
    MARK_READ(state, id) {
        const n = state.list.find((x) => x.id === id)
        if (n) n.read = true
    },
    MARK_ALL_READ(state) {
        state.list.forEach((n) => {
            n.read = true
        })
    },
    CLEAR(state) {
        state.list = []
    }
}
